'use strict';

module.exports = function (ngModule) {
    ngModule.directive('makeCoiChart', require('./makecoichart'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/coichart/index.js
 **/